<script>
import { authComputed } from "@/store/helpers";

export default {
  computed: {
    ...authComputed,
  },
  name: "NewDevice",
  inject: ["GStore"],

  data() {
    return {
      deviceName: "",
      tracerId: "",
    };
  },

  methods: {
    resetForm() {
      // Reset the form fields by setting their values to empty strings
      this.deviceName = "";
      this.tracerId = "";
    },

    addDevice() {
      let dataDev = {
        name: this.deviceName.toUpperCase(),
        tracerId: this.tracerId,

      };
      this.$store
        .dispatch("addDevice", dataDev)
        .then(() => {
          this.resetForm();
          this.GStore.flashMessage = "A new device was added";

          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 3000);
        })
        .catch(() => {
          this.GStore.flashMessage =
            "An unknown error occurred. Please try again later! ";

          setTimeout(() => {
            this.GStore.flashMessage = "";
          }, 3000);
        });
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="flashMessage" v-if="GStore.flashMessage">
        {{ GStore.flashMessage }}
      </div>
      <h1 class="vrm-page-title">New Device</h1>
      <br />

      <form @submit.prevent="addDevice">
        <fieldset class="fieldset">
          <div class="fieldset__item">
            <label class="fieldset__item__label sg-textfield-label sg-required">
              <span class="sg-textfield-label-caption">Device name</span>
            </label>
            <input v-model="deviceName" name="deviceName" class="sg-element" type="text" value />
          </div>
        </fieldset>
        <div>
          <button class="sg-btn sg-blue sg-element" type="submit" name="buttonLogin">
            Add device
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped lang="less"></style>
